<input
  class="ui-in"
  [class.size-s]="size() === 's'"
  [class.invalid]="invalid"
  [type]="type"
  [placeholder]="placeholder"
  [value]="value"
  [disabled]="disabled"
  [readonly]="readonly"
  [attr.maxlength]="maxlength"
  [attr.min]="min"
  [attr.max]="max"
  (input)="onInput($event)"
  (blur)="onBlur()"
/>
